import {useEffect, useMemo, useState} from "react";
import {Provider, Repo} from "../../api/types";
import {agent} from "../../api/agent";
import {CustomSelect} from "../permissions/CustomSelect";

interface Props {
    selectedRepo: string | null;
    setSelectedRepo: (repo: string | null) => void;
}

export default function RepoSelector({selectedRepo, setSelectedRepo}: Props) {
    const [providers, setProviders] = useState<Provider[] | null>(null);
    const [provider, setProvider] = useState<string | null>(null);
    const [selectedRepoName, setSelectedRepoName] = useState<string | null>(null);
    const [branches, setBranches] = useState<string[]>([]);
    const [selectedBranch, setSelectedBranch] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        agent.getProviders().then(setProviders);
    }, []);

    const currentRepo = () => {
        if (!provider) {
            return null;
        }
        if (!selectedRepoName) {
            return provider;
        }
        return provider + '/' + selectedRepoName + (!!selectedBranch ? ':' + selectedBranch : '');
    }



    useEffect(() => {
        setLoading(true);

        if (!providers) {
            return;
        }

        if (!selectedRepo || selectedRepo === '') {
            setLoading(false);
            setProvider(null);
            setSelectedRepoName(null);
            setSelectedBranch(null);
            return;
        }

        if (selectedRepo === currentRepo()) {
            setLoading(false);
            return;
        }

        const parts = selectedRepo.split('/');
        setProvider(parts[0]);
        if (selectedRepo.split(":")[0].split('/').length <= 1) {
            setSelectedRepoName(null);
        }else{
            setSelectedRepoName(selectedRepo.split(":")[0].split('/').slice(1).join('/'));
        }
        if (selectedRepo.split(":").length > 1) {
            setSelectedBranch(selectedRepo.split(":")[1]);
        }else{
            setSelectedBranch(null);
        }
        setLoading(false);
    }, [selectedRepo, providers]);

    const repos = useMemo(() => {
        if (!providers || !provider) {
            return [];
        }
        const selectedProvider = providers.find(p => p.id === provider);
        if (!selectedProvider) {
            return [];
        }
        const repoList: Repo[] = [];
        for (const repo of selectedProvider.repos) {
            if (!repoList.find(p => p.withoutBranch === repo.withoutBranch))
                repoList.push(repo);
        }
        return selectedProvider.repos;
    }, [providers, provider]);

    useEffect(() => {
        if (!providers || !provider) {
            setBranches([]);
            return;
        }
        const selectedProvider = providers.find(p => p.id === provider);
        if (!selectedProvider) {
            setBranches([]);
            return;
        }
        agent.getRepo(selectedProvider.id + '/' + selectedRepoName).then(value => {
            setBranches(value.branches);
        }).catch(value => {
            setBranches([]);
        })
    }, [providers, provider, selectedRepoName]);

    useEffect(() => {
        if (loading) {
            return;
        }
        setSelectedRepo(currentRepo());
    }, [provider, selectedRepoName, selectedBranch]);

    return (
        <>
            {providers && (
                <>
                    <CustomSelect options={providers.map(value => value.name) ?? []}
                                  value={providers.find(value => value.id === provider)?.name}
                                  onChange={(val, index) => {
                                      setProvider(providers!.find((val, i) => i === index)?.id ?? null);
                                  }}></CustomSelect>
                    <CustomSelect
                        options={repos.map(value => value.withoutBranch.substring((provider?.length ?? 0) + 1))}
                        value={selectedRepoName}
                        onChange={(val) => {
                            setSelectedRepoName(val);
                        }}
                        width={'25rem'}
                        allowCustom={true}
                    ></CustomSelect>
                    <CustomSelect
                        options={['None', ...branches]}
                        value={selectedBranch}
                        onChange={(val, index) => {
                            console.log(val, index);
                            if (index === 0) {
                                setSelectedBranch(null);
                                return;
                            }

                            setSelectedBranch(val);
                        }}
                        allowCustom={true}
                    ></CustomSelect>
                </>
            )}
        </>
    )

}

